import styled from 'styled-components';

const PageContainer = styled.div`
  width: 97%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

const ChartComponentsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 20px;
  @media (max-width: 1390px) {
    flex-direction: column;
  }
`;

const barChartContainer = styled.div`
  width: 100%;
  height: 100%;
  @media (max-width: 768px) {
    overflow-x: auto;
  }
`;

export default {
  PageContainer,
  ChartComponentsWrapper,
  barChartContainer,
};
